import * as r from "react";
import s from "../lib/SSRBase.es.js";
import t from "../defs/Cards.es.js";
const o = r.forwardRef((a, e) => /* @__PURE__ */ r.createElement(s, { ref: e, ...a, weights: t }));
o.displayName = "CardsIcon";
const d = o;
export {
  d as Cards,
  o as CardsIcon
};
